module.exports = __webpack_public_path__ + "img/background_c3-1_mobile.d4ec4415.jpg";